import { memo } from 'react';
import { sameNodeContent } from '../../Services/GraphRenderState';
import { Node, NodeProps } from '@xyflow/react';

import useFlowActivityMetadata from '../../Hooks/Metadata/useFlowActivityMetadata';
import { ActivityModel } from '../../Models/FlowModel';
import ActivityIcon from '../ActivityIcon';
import BaseNode from './BaseNode';
import './OnErrorNode.scss';

export const ON_ERROR_NODE_TYPE = 'on-error';

function OnErrorNode({ data, selected, id }: NodeProps & { data: ActivityModel }) {
	const activityMetadata = useFlowActivityMetadata(data.Type);

	return (
		<BaseNode id={id} data={data} selected={selected} activityMetadata={activityMetadata} nodeClassName="on-error-node">
			<div className="on-error-node__circle">
				<ActivityIcon activityMetadata={activityMetadata} />
			</div>
			<span className="on-error-node__label">{activityMetadata?.displayName ?? data.Type}</span>
		</BaseNode>
	);
}

export function nodeFromOnError(model: ActivityModel, x: number = 0, y: number = 0): Node<ActivityModel> {
	return {
		id: model.Id,
		type: ON_ERROR_NODE_TYPE,
		position: { x, y },
		data: model,
	} as Node<ActivityModel>;
}

export default memo(OnErrorNode, sameNodeContent);
